module.exports = __webpack_public_path__ + "media/images/proof_links/instagram-4e7d9b7a70da095a6ff831a5a019e3a9.svg";